(function () {
  "use strict";

  const navigation = new Navigation(document.getElementById("navigation"));

  function heroSlider() {
    if (document.querySelector('.hero-slider')) {
      const slideContents = document.querySelectorAll('.hero-slider .swiper-slide')
      slideContents[0].classList.add('active-content')

      const swiper = new Swiper('.hero-slider .swiper', {
        loop: true,
        on: {
          slideChangeTransitionStart: function () {
            // Get the current slide index
            var slideIndex = this.realIndex;
            console.log(slideIndex);

            slideContents.forEach((item, itemIndex) => {
              const index = itemIndex;
              if (index == slideIndex) {
                setTimeout(() => {
                  item.classList.add("active-content");
                }, 750);
              } else {
                setTimeout(() => {
                  item.classList.remove("active-content");
                }, 750);
              }
            });
          },
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: '.hero-slider .slider-button-next',
          prevEl: '.hero-slider .slider-button-prev',
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
      })
    }
  }

  // Projeler Section Slider
  function projelerSectionSlider() {
    if (document.querySelector('.projeler-section-slider')) {
      const slider = new Swiper('.projeler-section-slider .swiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: ".projeler-section .slider-button-next",
          prevEl: ".projeler-section .slider-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },

        }
      })
    }
  }


  // Haberler Section Slider
  function haberlerSectionSlider() {
    if (document.querySelector('.haberler-section-slider')) {
      const slider = new Swiper('.haberler-section-slider .swiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: ".haberler-section .slider-button-next",
          prevEl: ".haberler-section .slider-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },

        }
      })
    }
  }

  // Blog Section Slider
  function blogSectionSlider() {
    if (document.querySelector('.blog-section-slider')) {
      const slider = new Swiper('.blog-section-slider .swiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: ".blog-section .slider-button-next",
          prevEl: ".blog-section .slider-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },

        }
      })
    }
  }

  function urunDetaySlider() {
    if (document.querySelector('.urun-detay-slider')) {

      const swiper = new Swiper(".urun-detay-thumbs", {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
      });

      const swiper2 = new Swiper(".urun-detay-slides", {
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: swiper,
        },
      });
    }
  }
  function projeModalSlider() {
    if (document.querySelector('.proje-modal-slider')) {

      const swiper = new Swiper(".proje-modal-slider .swiper", {
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  }

  // Intl Tel Input

  function telefonInput() {
    const input = document.querySelector("#phone");
    window.intlTelInput(input, {
      // allowDropdown: false,
      // autoPlaceholder: "off",
      // containerClass: "test",
      // countryOrder: ["jp", "kr"],
      // customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
      //   return "e.g. " + selectedCountryPlaceholder;
      // },
      // dropdownContainer: document.querySelector('#custom-container'),
      // excludeCountries: ["us"],
      // fixDropdownWidth: false,
      // formatAsYouType: false,
      // formatOnDisplay: false,
      // geoIpLookup: function(callback) {
      //   fetch("https://ipapi.co/json")
      //     .then(function(res) { return res.json(); })
      //     .then(function(data) { callback(data.country_code); })
      //     .catch(function() { callback(); });
      // },
      // hiddenInput: () => "phone_full",
      // i18n: { 'de': 'Deutschland' },
      initialCountry: "us",
      // nationalMode: false,
      // onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
      // placeholderNumberType: "MOBILE",
      // showFlags: false,
      // separateDialCode: true,
      // strictMode: true,
      // useFullscreenPopup: true,
      utilsScript: "./utils.js",
    });
  }

  // Scroll top Button

  function scrollTop() {
    const btnScrollTop = document.getElementById('scrollTop')
    document.addEventListener('scroll', () => {
      if (window.scrollY > 1000) {
        btnScrollTop.classList.remove('hide-btn');
      } else {
        btnScrollTop.classList.add('hide-btn');
      }
    })

    btnScrollTop.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    })
  }

  function scrollY() {
    let scrollpos = window.scrollY
    const header = document.getElementById('navigation')
    const header_height = header.offsetHeight

    const add_class_on_scroll = () => header.classList.add("active")
    const remove_class_on_scroll = () => header.classList.remove("active")

    window.addEventListener('scroll', function () {
      scrollpos = window.scrollY;

      if (scrollpos >= header_height) { add_class_on_scroll() }
      else { remove_class_on_scroll() }

      console.log(scrollpos)
    })

  }

  function toggleSearch() {
    const searchButtons = document.querySelectorAll('[data-search-button]')
    const searchBox = document.querySelector('.search-box')
    const searchClickArea = document.querySelector('.search-click-area')
    const searchInput = searchBox.querySelector('input')

    searchButtons.forEach((btn) => {
      btn.addEventListener('click', toggle)
    })

    function toggle() {
      !searchBox.classList.contains('active') ? add() : remove()
    }

    function add() {
      searchBox.classList.add('active')
      searchInput.focus()
    }
    function remove() {
      searchBox.classList.remove('active')
    }

    searchClickArea.addEventListener('click', remove)
  }

  function fixLinks() {
    let scrollpos = window.scrollY
    const header = document.querySelector(".fix-links")
    const header_height = header.offsetHeight
    const add_class_on_scroll = () => header.classList.add("active")
    const remove_class_on_scroll = () => header.classList.remove("active")
    window.addEventListener('scroll', function () {
      scrollpos = window.scrollY;
      if (scrollpos >= header_height) { add_class_on_scroll() }
      else { remove_class_on_scroll() }
    })
  }

  heroSlider()
  projelerSectionSlider()
  haberlerSectionSlider()
  blogSectionSlider()
  urunDetaySlider()
  projeModalSlider()
  scrollY()
  toggleSearch()
  fixLinks()
  // telefonInput()
  // initAcc('.accordion.v1', true);
  // uygulamalarSlider()
  // scrollTop()


})();